import React from 'react';
import RodoDisclaimer from '.rodo-disclaimer.json';
import parse from 'html-react-parser';

const RodoText = (): React.JSX.Element => <div>{parse(RodoDisclaimer.content.content)}</div>;

export default RodoText;
